<template>
  <div>
    <!-- <auth-header :page-title="'Sign in to continue'"></auth-header> -->

    <div class="card-body">
      <form class="form-horizontal auth-form my-4" @submit.prevent="login">
        <div class="form-group">
          <label for="username">Username (Phone or Email)</label>
          <div class="input-group mb-3">
            <input type="type" class="form-control" v-model="state.form.body.username"
              placeholder="Enter phone or email address" />
          </div>
        </div>

        <div class="form-group">
          <label for="userpassword">Password</label>
          <div class="input-group mb-3">
            <input type="password" class="form-control" placeholder="Enter password"
              v-model="state.form.body.password" />
          </div>

          <!-- <div class="text-danger text-sm">
                {{ state.form.errors.password }}
                </div> -->
        </div>

        <div class="form-group row mt-4">
          <div class="col-sm-6">
            <div class="custom-control custom-switch switch-info">
              <input type="checkbox" class="custom-control-input" id="customSwitchInfo" v-model="state.form.remember" />
              <label class="custom-control-label text-muted" for="customSwitchInfo">
                Remember me
              </label>
            </div>
          </div>

          <div class="col-sm-6 text-right">
            <router-link :to="{ name: 'forgotpassword' }" class="text-muted font-13" @click.prevent="setUserType">
              <i class="dripicons-lock"></i> Forgot password?
            </router-link>
          </div>
        </div>

        <hr />

        <div class="form-group mb-0 row">
          <div class="col-12 mt-2">
            <button class="btn btn-primary btn-block waves-effect waves-light" type="submit">
              Log In
              <i class="fas fa-sign-in-alt ml-1"></i>
            </button>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-6">
            <p class="mb-0 text-muted">
              Don't have an account ?
              <router-link :to="{ name: 'registerStep1' }" class="text-primary ml-2">Register</router-link>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { handleError } from "./../../../utils";
import localStorageService from "../../../services/LocalStorageService"

const module = "auth";
const userModule = "users";

export default defineComponent({
  name: "Login",
  props: ["companyColor"],

  setup(props) {
    // console.log("companyColor props ==== ", props.companyColor);
    const store = useStore();
    const router = useRouter();
    let loggedIn = ref(false);
    let twofactor = ref(false);

    const state = reactive({
      form: {
        body: {
          username: "",
          password: "",
          user_type: "CUSTOMER",
        },
        remember: false,
        fetchUser: true,
        staySignedIn: true,
        // errors: {},
      },
    });

    function setUserType() {
      let data = { user_type: 'CUSTOMER' }
      localStorageService.saveData('forgot_password', data);
      router.push({ name: 'forgotpassword' })
    }

    async function login() {
      try {
        const res = await store.dispatch(`${module}/login`, state.form.body);
        localStorageService.saveData('login_user_type', 'CUSTOMER')
        router.push({ name: "2fa" });
      } catch (err) {
        let error_message = handleError(err.data);
        createToast(error_message, {
          type: "error",
          position: "bottom-right",
          transition: "bounce",
          showIcon: true,
          timeout: 4000,
        });
      }
    }

    onMounted(() => {
      ['otpVerifiedSuccessfully', 'addressDetailsFilled', '2fa', 'stagingProfileData', 'user_register'].forEach(key => sessionStorage.removeItem(key));

    })
    loggedIn.value = computed(() => {
      return store.state.auth.status.loggedIn;
    });

    if (loggedIn.value == true) {
      // console.log("loggedIn **** ");
      router.replace({ name: "customerHome" });
    }

    twofactor.value = computed(() => {
      return store.state.auth.status.twofactor;
    });

    if (twofactor.value == true) {
      // console.log("2fa needed **** ");
      router.replace({ name: "2fa" });
    }

    return {
      state,
      login,
      twofactor,
      loggedIn,
      setUserType,
      pageTitle: "Sign In",
    };
  },
});
</script>

<style scoped>
.account-body .auth-header-box {
  background-color: #0c213a;
}
</style>
